import ButtonT from '@components/tailwind-components/Button/ButtonT';
import { useModal } from '@hooks/modal/useModal';
import { useTranslation } from 'react-i18next';
import { useMainSelector } from '../../../hooks/useMainSelector';
import { useRevisionsActions } from '../useRevisionsActions';

interface ModalRevisionSetContentBodyProps {
  revisionId: string;
}

export const RevisionSetDefaultModal: React.FC<
  ModalRevisionSetContentBodyProps
> = (props) => {
  const { revisionId } = props;
  const { setMainRevision } = useRevisionsActions();
  const { hideModal } = useModal();
  const {
    designer: { revisions },
  } = useMainSelector();
  const { t } = useTranslation();

  const setMainRevisionAction = () => {
    void setMainRevision(revisionId, revisions as any);
    hideModal();
  };

  return (
    <div className='tailwind-modal-form'>
      <div className='tailwind-modal-body'>
        <p className='text-sm'>
          {t('modals.description.set-main-revision', {
            name: revisionId,
          })}
        </p>
        <br />
        <p className='text-sm italic'>
          {t('modals.description.set-main-revision-desc')}
        </p>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='submit'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => hideModal()}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={() => setMainRevisionAction()}>
          {t('modals.confirm.yes')}
        </ButtonT>
      </div>
    </div>
  );
};
